import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import DetailTextButton from '../atoms/DetailTextButton';
import RegisterTextButton from '../atoms/RegisterTextButton';

const styles = {};

const enhance = compose(pure);

const ShopTableBody = enhance(
  ({
    preShops,
    emptyRows,
    page,
    rowsPerPage,
    detailOpenAction,
    registerOpenAction
  }) => {
    return (
      <TableBody>
        {preShops
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map(preShop => {
            const params = {
              id: preShop.preShopId,
              unregistered: preShop.unregistered
            };
            const key = `${preShop.preShopId}-${String(preShop.unregistered)}`;
            return (
              <TableRow key={key}>
                <TableCell>
                  <RegisterTextButton
                    params={params}
                    onClickAction={registerOpenAction}
                    enabled="true"
                  />
                </TableCell>
                <TableCell>{preShop.preShopName}</TableCell>
                <TableCell>
                  {preShop.prefectures}
                  {` `}
                  {preShop.city}
                  {` `}
                  {preShop.address}
                  {` `}
                  {preShop.building}
                </TableCell>
                <TableCell>{preShop.phone}</TableCell>
                <TableCell>
                  <DetailTextButton
                    params={params}
                    onClickAction={detailOpenAction}
                  />
                </TableCell>
              </TableRow>
            );
          })}
        {emptyRows > 0 && (
          <TableRow style={{ height: 49 * emptyRows }}>
            <TableCell colSpan={7} />
          </TableRow>
        )}
      </TableBody>
    );
  }
);

export default withStyles(styles)(ShopTableBody);
